module.exports = __webpack_public_path__ + "static/media/drag.b24af282.svg";